<template>
  <div>
    <v-card>
      <v-card-title>
        <span>{{$t('upcoming_payment_details')}} {{ userName }}</span>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="$router.go(-1)" class="mx-1">
          {{$t('back')}}
          <v-icon right dark> mdi-keyboard-return </v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :no-data-text="$t('noData')"
        :no-results-text="$t('noResults')"
        item-key="id"
        :loading="isLoading"
        :loading-text="$t('loading_text')"
        :headers="translatedHeaders"
        :items="paymentDetail"
        :search="search"
        :footer-props="footerProps"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            class="mx-4"
          ></v-text-field>
        </template>
      </v-data-table>
    </v-card>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      paymentDetail: [],
      userName: "",
      user_id: null,
      isLoading: false,
      search: "",
      headers: [
        { text: "id", value: "id", align: "start", filterable: false },
        { text: "date", value: "payment_date" },
        { text: "amount", value: "amount" },
        { text: "route", value: "reservation.planned_trip.route.name" },
        { text: "from", value: "reservation.first_stop.name" },
        { text: "to", value: "reservation.last_stop.name" },
      ],
    };
  },
  computed: {
    translatedHeaders() {
      return this.headers.map(header => ({
        ...header,
        text: this.$t(header.text)
      }));
    },
    footerProps() {
      return {
        itemsPerPageText: this.$t("rows_per_page"),
      }
    }
  },
  mounted() {
    if (this.$route.params.user_id != null) {
      this.user_id = this.$route.params.user_id;
      this.fetchPayments()
    }
  },
  methods: {
    fetchPayments() {
      this.isLoading = true;
      this.paymentDetail = [];
      axios
        .get(`/users/payment-details`, {
          params: {
            user_id: this.user_id,
          },
        })
        .then((response) => {
          this.paymentDetail = response.data.payment_details;
          this.userName = response.data.user_name;
          console.log(response.data);
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("Error"),
            text: this.$t("error_retrieving_payment_details"),
            type: "error",
          });
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
